<div class="chat-wrapper">
  <!-- Reply indicator shown when replying to a message -->
  <div *ngIf="replyToMessage" class="reply-indicator">
    <span>Replying to {{ replyToMessage.author.name }}</span>
    <dx-button
      icon="close"
      stylingMode="text"
      (onClick)="cancelReply()"
    ></dx-button>
  </div>

  <dx-chat data-testid="chat-chat-container" #chatComponent
    (onTypingStart)="onTypingStart($event)"
    (onTypingEnd)="onTypingEnd($event)"
    [items]="messages$ | async"
    (onMessageEntered)="onMessageEntered($event)"
    (onContextMenuPreparing)="onContextMenuPreparing($event)"
    [user]="user"
    [textContent]="textContent"
    [typingUsers]="typingUsers"
    class="chat-container"

  ></dx-chat>

</div>
<dx-popup data-testid="userLookup" #userPopup
    height="250"
    width="300"
    [position]="{ my: 'left top', at: 'left bottom', of: 'textarea' }"
    [showCloseButton] = "false"
    [showTitle]="false"
    id="userLookup"
    [(visible)]="popupVisible"
    contentTemplate="popupContent"
    [shading]="false"
    [focusStateEnabled]="false"
    [dragEnabled]="false"
    [resizeEnabled]="false"
    >

    <div *dxTemplate="let data of 'popupContent'">
      <dx-list data-testid="chat-list"
        [dataSource]="filteredUsers"
        [height]="200"
        displayExpr="fullName"
        [searchEnabled]="false"
        (onItemClick)="onUserSelected($event)"
        [showSelectionControls]="false"
        [focusStateEnabled]="false">
        <div *dxTemplate="let user of 'item'">
          <div
            data-testid="chat-user-item"
            class="user-item"
            [class.keyboard-selected]="isMentionSelected(user)">
            <div data-testid="chat-user-name" class="user-name">{{ user.fullName }}</div>
            <div data-testid="chat-user-email" class="user-email">{{ user.email }}</div>
          </div>
        </div>
      </dx-list>
    </div>



</dx-popup>
